import { FC } from 'react'
import { LinkStyle } from './LinkStyle'
import { LinkThemeState } from './types'
import { LockModalVariants } from '@dtx-company/inter-app/src/constants/lockModal'
import { ProFeatureWrapper } from '@app/code/src/components/ProFeatureWrapper'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useIsMobile } from '@dtx-company/true-common/src/hooks/useIsMobile'
import events from '@dtx-company/inter-app/src/event-tracking/events/flowpage'

export const LinkLevelStylingTooltipContent: FC = () => {
  return (
    <>
      <Text variant="body/small" color="primary.white" fontWeight="700" mb="5px">
        Customize your link&apos;s look and feel
      </Text>
      <Text variant="body/small" color="primary.white">
        You can change your link&apos;s border, background, text and shade colors to match your
        brand.
      </Text>
    </>
  )
}

export const LinkStyleGated = (props: LinkThemeState): JSX.Element => {
  const { hasOperation } = useAuthState()
  const canViewLinkStyleOptions = hasOperation('view:link_style_options')
  const isMobile = useIsMobile()

  if (canViewLinkStyleOptions) return <LinkStyle {...props} />
  return (
    <ProFeatureWrapper
      sourceId=""
      gateFeatureAndHideTooltip={isMobile}
      showTooltip={!isMobile}
      lockModalVariant={LockModalVariants.FP_LINK_LEVEL_STYLING}
      tooltipId="link-level-styling-tooltip"
      content={<LinkLevelStylingTooltipContent />}
      trackingCall={events.Flowpage_PageProfile_Clicked_Link_Level_Customization_Options}
      alignItems="center"
      isProPlus={true}
    >
      <LinkStyle {...props} disabled={true} />
    </ProFeatureWrapper>
  )
}
